import React from 'react'
import {motion} from 'framer-motion';
import { AppWrap,MotionWrap } from '../../wrapper';
import {images} from '../../constants'
import './Work.scss'
import CTA from './CTA';


const works = [
  {
    title:'Dental Implant' , description: 'It replaces one or two missing tooth, & fix your jaw!' , 
    imgURL: images.dentalimplant
   },

   {
    title:'Dentures' , description: 'False teeth, which will replace teeth that you have lost!' , 
    imgURL: images.dentures
   },
  
   {
    title:'Tooth Fillings' , description: 'All types of Fillings are available at our clinic at best rates!' , 
    imgURL: images.fillings
   },
   
   {
    title:'Teeth Whitening' , description: 'Bleaching of teeth at very affordable rates at our clinic' , 
    imgURL: images.white
   },
   



   {
    title:'Invisalign' , description: ' Orthodontic treatment that straightens teeth without the use of metal braces.' , 
    imgURL: images.invaslign
   },
   {
    title:'Dental Bridges' , description: 'All type of Dental Bridges treatment are done at our clinic.' , 
    imgURL: images.bridges
   }, 
   {
    title:'Root Canal' , description: 'To repair and save a badly damaged or infected tooth instead of removing it' , 
    imgURL: images.rootcanal
   }, 
   {
    title:'Scaling and Polishing' , description: 'Your teeth will shine brightly once the tooth stain is erased. Affordable rates at our clinic ' , 
    imgURL: images.scaling
   }, 
   {
    title:'Wisdom Tooth' , description: 'If your last set of adult teeth or last molar causes complications, they need to be extracted before they hurt.' , 
    imgURL: images.wisdom
   }, 
  
  

];

const Work = () => {
  return (

    <>
    <h2 className='head-text'>Creating   <span>Miles</span> <br/>
     of <span> Smiles </span> 😄 </h2>

     <div className='app__profiles'>
        {works.map((work,index)=>(
          <motion.div
            whileInView={{opacity:1}}
            whileHover={{scale:1.1}}
            transition={{duration: 0.5, type:'tween'}}
            className = "app__profile-item"
            key={work.title +index}
          >
            <img src={work.imgURL} alt={work.title}/>
           
            <h2 className='bold-text' style={{marginTop:20}}> {work.title} </h2>
            <p className='p-text' style={{marginTop:10}}> {work.description} </p>
            <CTA/>
          </motion.div>
        
         
          
        ))}
      </div>

  
     </>
  
  )  
}

export default AppWrap(
  MotionWrap(Work,'app__work'),
  'work',"app__primarybg");
  